import React from "react";

import HeaderMfd from "./HeaderMfd";
import BannerMfd from "./components/BannerMfd";
import MarqueeSlide from "./components/MarqueeSlide";
import CoreFeatures from "./components/CoreFeatures";
import PricingMfd from "./components/PricingMfd";
import Integrations from "./components/Integrations";
import ContactUs from "./components/ContactUs";
import FaqMfd from "./components/FaqMfd";
import ConvertLeads from "./components/ConvertLeads";
import FooterMfd from "./components/FooterMfd";
import SalesDemo from "./components/SalesDemo";

const Home = () => {
    return (
        <>
            <HeaderMfd />
 
            <BannerMfd />

           

            <MarqueeSlide />

            <CoreFeatures />

            <PricingMfd />

            <Integrations />

            <ContactUs />

            <FaqMfd />

            <ConvertLeads />

            <FooterMfd />
        </>
    );
};

export default Home;
